"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkBox = exports.LayoutBookmarkBoxType = void 0;
var tslib_1 = require("tslib");
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var LayoutBookmarkBoxType;
(function (LayoutBookmarkBoxType) {
    LayoutBookmarkBoxType[LayoutBookmarkBoxType["StartBox"] = 0] = "StartBox";
    LayoutBookmarkBoxType[LayoutBookmarkBoxType["EndBox"] = 1] = "EndBox";
})(LayoutBookmarkBoxType = exports.LayoutBookmarkBoxType || (exports.LayoutBookmarkBoxType = {}));
var BookmarkBox = (function (_super) {
    tslib_1.__extends(BookmarkBox, _super);
    function BookmarkBox(boxType) {
        var _this = _super.call(this, 0, 0, 0, 0) || this;
        _this.boxType = LayoutBookmarkBoxType.StartBox;
        _this.color = "";
        _this.boxType = boxType;
        return _this;
    }
    BookmarkBox.prototype.equals = function (obj) {
        return _super.prototype.equals.call(this, obj) &&
            this.color == obj.color &&
            this.boxType == obj.boxType;
    };
    BookmarkBox.DEFAULT_WIDTH = 3;
    BookmarkBox.DEFAULT_BORDER_WIDTH = 2;
    return BookmarkBox;
}(rectangle_1.Rectangle));
exports.BookmarkBox = BookmarkBox;
